<template>
    <div class="overflow-hidden rounded-card border border-panel-border bg-white">
        <div class="bg-panel px-4 py-1.5">
            <h4 class="!mb-0 text-xs !font-bold">
                {{ trans('workorder.troubleshooting.title') }}
                <em v-if="!readonly" class="text-danger">*</em>
            </h4>
        </div>

        <div class="px-4 py-3">
            <p class="!mb-2.5 text-[14px]">{{ trans('workorder.troubleshooting.question') }}</p>
            <yes-no-selector
                :disabled="readonly"
                :model-value="value.troubleshot"
                test-id="troubleshooting-troubleshot"
                @update:model-value="updateField('troubleshot', $event)"
            />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import YesNoSelector from '@/Components/YesNoSelector.vue';
import { trans } from '@/mixins/i18n.js';

const props = defineProps({
    modelValue: { type: Object, default: () => ({}) },
    readonly: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue']);

const value = computed(() => props.modelValue ?? {});

const updateField = (key, val) => {
    emit('update:modelValue', { ...value.value, [key]: val });
};
</script>
